const excludedScripts = ["jquery", "wp-polyfill-js"];

export function rerunAllScriptsInCanvasDocumentBody() {
  const canvasDocument = window.Breakdance.canvas.document;
  const allScripts = canvasDocument.querySelectorAll(
    // only the direct children of the body
    `script`
  ) as NodeListOf<HTMLScriptElement>;

  for (const script of allScripts) {
    if (
      excludedScripts.find(
        excludedScript =>
          script.id.toLowerCase().includes(excludedScript) ||
          script.src.toLowerCase().includes(excludedScript)
      )
    ) {
      continue;
    }

    const newScript = cloneScriptNode(script);

    script.remove();
    canvasDocument.querySelector("body")?.appendChild(newScript);
  }
}

function cloneScriptNode(scriptNode: HTMLScriptElement) {
  const newScriptNode = document.createElement("script");

  Array.from(scriptNode.attributes).forEach(attr => {
    newScriptNode.setAttribute(attr.name, attr.value);
  });

  if (scriptNode.src) {
    newScriptNode.src = scriptNode.src;
  } else {
    newScriptNode.innerHTML = scriptNode.innerHTML;
  }

  return newScriptNode;
}
